import React, { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { useStateMachine } from '@isdd/metais-common/components/state-machine/hooks/useStateMachine'
import { StandardDraftsDraftStates } from '@isdd/metais-common/types/api'

import { getPopupContentWithPermissions } from '@/componentHelpers/draftsList'
import { useStandartDraftStateMachine } from './useStandardDraftStateMachine'

interface IDraftsListButtonPopupContent {
    onClick: (incomingState: string) => void
}

export const DraftsListButtonPopupContent = ({ onClick }: IDraftsListButtonPopupContent) => {
    const machine = useStandartDraftStateMachine()

    const allPosibleSteps = machine?.allPossibleTransitions

    const { t } = useTranslation()

    return {
        component: <>{getPopupContentWithPermissions(allPosibleSteps, t, onClick)}</>,
        allPosibleSteps,
    }
}
